import React from 'react';
import { Box, Typography } from '@mui/material';

const NO_DATA = 'Not Provided';
const PatientDetailsBiochemicalSummaryPanel = ({ biochemicalData, potentialConditionsString }) => (
  <>
    <Box sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box' }}>
      <Typography variant="h2" align='center' sx={{ fontSize: '1.2rem', mb: 2 }}>Potential Conditions</Typography>
      <Typography
        variant="body1"
        className="potential-conditions-string"
        align='center'
        sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
      >
        {potentialConditionsString && potentialConditionsString.length > 0
          ? potentialConditionsString.replace(/,(\S)/g, ', $1')
          : <em>No data</em>}
      </Typography>
    </Box>
    <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box' }}>
      <Typography variant="h2" align='center' sx={{ fontSize: '1.2rem', mb: 2 }}>Patient Data</Typography>
      <Typography variant="body1">Sex: {biochemicalData?.sex ?? <em>{NO_DATA}</em>}</Typography>
      <Typography variant="body1">Birth Weight: {biochemicalData.birthWeight != null ? biochemicalData.birthWeight + " grams" : <em>{NO_DATA}</em>}</Typography>
      <Typography variant="body1">Gestational Age: {biochemicalData?.gestationalAge ?? <em>{NO_DATA}</em>}</Typography> 
      <Typography variant="body1">Race: {biochemicalData?.race ?? <em>{NO_DATA}</em>}</Typography>
      <Typography variant="body1">Ethnicity: {biochemicalData?.ethnicity ?? <em>{NO_DATA}</em>}</Typography>
      <Typography variant="body1">TPN: {biochemicalData?.TPN ?? <em>{NO_DATA}</em>}</Typography>
      <Typography variant="body1">Transfusion: {biochemicalData?.transfusion ?? <em>{NO_DATA}</em>}</Typography>
    </Box>
  </>
);

export default PatientDetailsBiochemicalSummaryPanel;